interface CardSourceMeta {
  category?: string | null
  tags?: string[]
  source?: string
}

/** 申论积累卡由每日精读自动生成，来源通常是文章 URL。 */
export function isEssayAccumulationCard(card: CardSourceMeta) {
  return card.category === '申论' && (card.tags || []).includes('每日精读')
}

/** 自动生成的申论文章来源不进入任何手工卡片的知识来源候选列表。 */
export function isKnowledgeSourceSuggestionCard(card: CardSourceMeta) {
  return !isEssayAccumulationCard(card)
}

